/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Integrations_HintInputs */

const en_settings_v2_integrations_hint = /** @type {(inputs: Settings_V2_Integrations_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import from other services`)
};

const es_settings_v2_integrations_hint = /** @type {(inputs: Settings_V2_Integrations_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar de otros servicios`)
};

/**
* | output |
* | --- |
* | "Import from other services" |
*
* @param {Settings_V2_Integrations_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_integrations_hint = /** @type {((inputs?: Settings_V2_Integrations_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Integrations_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_integrations_hint(inputs)
	return en_settings_v2_integrations_hint(inputs)
});